module.exports = "<router-outlet></router-outlet>"


//////////////////
// WEBPACK FOOTER
// ./src/app/Pages/tasks/patientstatus/patientstatus.component.html
// module id = ./src/app/Pages/tasks/patientstatus/patientstatus.component.html
// module chunks = main